<xemex-table
  [data]="tableData()"
  [columns]="columns"
  [loading]="closedLoading()"
  [pageable]="true"
>
  <xemex-table-filter-bar
    [filterGroups]="filterGroups()"
    [searchPlaceholder]="'devices.alarms.searchPlaceholder' | translate"
    (searchChange)="query.set($event)"
    (filterChange)="activeFilters.set($event)"
  ></xemex-table-filter-bar>

  <ng-template #actionsCell let-row>
    @if (row.canClose) {
      <button
        mat-icon-button
        (click)="onCloseStatus(row); $event.stopPropagation()"
        [title]="'devices.alarms.closeAction' | translate"
      >
        <mat-icon>check_circle_outline</mat-icon>
      </button>
    }
  </ng-template>
</xemex-table>
